import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { SendEmailNodeData } from '../../../node-edit.type';
import { OrgUsersSelectComponent } from '../../org-users-select/org-users-select.component';
import { ContactsSelectComponent } from '../../contacts-select/contacts-select.component';
import { CreateEmailContactDialogComponent } from './components/create-email-contact-dialog/create-email-contact-dialog.component';
import { ValidatorsHelpers } from 'src/app/helpers/validators.helpers';
import { allEventVariables } from '@consts/alerts-v2.const';
import { UiTextAreaVariablesComponent } from 'src/app/shared/ui-kit/ui-text-area-variables/ui-text-area-variables.component';

@Component({
  selector: 'edit-send-email',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    OrgUsersSelectComponent,
    ContactsSelectComponent,
    UiTextAreaVariablesComponent,
  ],
  templateUrl: './edit-send-email.component.html',
  styleUrl: './edit-send-email.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditSendEmailComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditSendEmailComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<SendEmailNodeData>>();
  public disableForm = input<boolean>(false);

  public createEmailContactDialogComponent = CreateEmailContactDialogComponent;
  public readonly selectVariablesAutoComplete = allEventVariables;

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form: UntypedFormGroup = this.fb.group({
    name: [
      this.translateService.instant('FLOW_CHART.NODES.SEND_EMAIL.NAME'),
      [Validators.required],
    ],
    orgUsersIds: [[]],
    contactsIds: [[]],
    body: [''],
    subject: ['', [Validators.required]],
  },
    {
      validators: ValidatorsHelpers.atLeastOneRecipientValidator
    });

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        orgUsersIds: this.selectedNodeForEdit().data.orgUsersIds || [],
        contactsIds: this.selectedNodeForEdit().data.contactsIds || [],
        body: this.selectedNodeForEdit().data.body || '',
        subject: this.selectedNodeForEdit().data.subject || '',
      })
    }
  }
}
